import {Icon as XpsIcon} from 'xps-react';
import React from "react";

type IconProps = {
    color?: string,
    name: string,
    size?: string,
    className?: string,
    ariaHidden?: boolean,
    ariaLabel?: string,
    type?: 'success' | 'warning' | 'error' | 'info'| 'neutral',
    style?: React.CSSProperties
};

const Icon = ({ color, ...props }: IconProps) => {
    let style = {...(props.style ?? {})};
    style = color ?  {...style, color: color} : style;

    return <XpsIcon {...props} style={style} />;
}

export default Icon;
